import { render, staticRenderFns } from "./Selector.vue?vue&type=template&id=3b48c5a8"
import script from "./Selector.vue?vue&type=script&lang=js"
export * from "./Selector.vue?vue&type=script&lang=js"
import style0 from "./Selector.vue?vue&type=style&index=0&id=3b48c5a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports